module.exports = __webpack_public_path__ + "img/Wave.c10dd413.svg";